import { isMac } from '@/common/constants'

export const searchShortcutKeys = isMac ? ['⌘', 'K'] : ['Ctrl', 'K']
